import { render, staticRenderFns } from "./JobDescription.vue?vue&type=template&id=a04aa61c&"
import script from "./JobDescription.vue?vue&type=script&lang=js&"
export * from "./JobDescription.vue?vue&type=script&lang=js&"
import style0 from "./JobDescription.vue?vue&type=style&index=0&id=a04aa61c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports